// extracted by mini-css-extract-plugin
export default {"base":"base__label__MWAQc","inline":"inline__label__KEP9H","size-tiny":"size-tiny__label__fZry2","size-small":"size-small__label__V7RKG"};